import { Skeleton } from "@/components/ui/skeleton";

interface AuditLogSkeletonProps {
  rows?: number;
}

// Mirrors AuditLogRow, including its responsive stacking: avatar, a flowing
// action sentence over a payload line, then badge + timestamp that sit inline
// at lg and wrap underneath below it.
const SENTENCES = ["w-80", "w-96", "w-72", "w-[22rem]", "w-64"];

export default function AuditLogSkeleton({ rows = 7 }: AuditLogSkeletonProps) {
  return (
    <div role="status" aria-label="Loading audit events">
      {Array.from({ length: rows }, (_, row) => (
        <div
          key={row}
          className="flex gap-3 border-b border-dash-border px-4 py-4 last:border-b-0 sm:gap-4 sm:px-6 lg:items-center"
        >
          <Skeleton className="size-9 shrink-0 rounded-full" />

          <div className="flex min-w-0 flex-1 flex-col gap-2 lg:flex-row lg:items-center lg:gap-4">
            <div className="min-w-0 flex-1 space-y-2">
              <Skeleton className={`h-4 max-w-full ${SENTENCES[row % SENTENCES.length]}`} />
              <Skeleton className="h-3 w-48 max-w-full" />
            </div>

            <div className="flex flex-wrap items-center gap-x-3 gap-y-1 lg:shrink-0 lg:flex-nowrap lg:gap-4">
              <Skeleton className="h-5 w-28 rounded-full" />
              <Skeleton className="h-3 w-32" />
            </div>
          </div>
        </div>
      ))}
      <span className="sr-only">Loading audit events…</span>
    </div>
  );
}
